import { createSelector } from 'reselect'
import productNameTypes from 'helpers/enums/productNameTypes'

const getUserData = state => state.user.data

const userIsPremiumSelector = createSelector(
	[ getUserData ],
	userData => {
		let isPremiumUser = false
		if (userData && userData.type) {
			isPremiumUser = [productNameTypes.SCHOOL, productNameTypes.DISTRICT, productNameTypes.PLATINUM].includes(userData.type.toLowerCase())
		}
		return isPremiumUser
	}
)

export default userIsPremiumSelector
